module.exports = {
 //development server url
  URL: "http://localhost:3001",
   //production server url
  // URL: "https://gmandi-backend.herokuapp.com"
};
